// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name='Separator'] {\n  height: 1px;\n  width: 100%;\n  background-color: var(--separator-color);\n}\n", ""]);
// Exports
module.exports = exports;
